export const styleThresholds = {width: 640, height: 640}